@if ({facetList: facetList$ | async, currentCategory: currentCategory$ | async}; as type) {
  @if (type.facetList != null && type.currentCategory != null) {
    <section class="inner"
      [attr.aria-label]="'productFacetNavigation.filterBy.facet' | cxTranslate"
      [cxFocus]="isDialog ? dialogFocusConfig : {}" [tabindex]="-1" (esc)="close($event)" (click)="block($event)">
      <div class="list-header">
        <h4>{{ 'productList.filterBy.label' | cxTranslate }}</h4>
        <button type="button" class="close" title="{{ 'common.close' | cxTranslate }}"
          [attr.aria-label]="'common.close' | cxTranslate" (click)="close()">
          <cx-icon aria-hidden="true" [type]="iconTypes.CLOSE"></cx-icon>
        </button>
      </div>
      <cx-tab [tabs$]="tabs$" [config]="tabConfig"></cx-tab>
      @for (facet of type.facetList.facets; track facet) {
        <ng-template #facetsRef>
          <app-efa-facet [facet]="getVisibilityAugmentedFacet(facet, type.facetList.activeFacets, type.currentCategory)"
                role="group" attr.aria-label="{{
          'productFacetNavigation.ariaLabelItemsAvailable'
            | cxTranslate
              : {
                  name: facet.name,
                  count: facet?.values?.length,
                }
        }}" [currentCategory]="type.currentCategory"></app-efa-facet>
      </ng-template>
    }
    @if (isDialog) {
      <div class="cx-facet-list-footer">
        <button #backToResultsBtn class="btn btn-primary" (click)="close()" cxAutoFocus>
          {{ 'productFacetNavigation.backToResults' | cxTranslate }}
        </button>
      </div>
    }
  </section>
}
}